import { performDraw, addTelemetryMetrics, noop, timeStampNow, elapsed } from '@datadog/browser-core';
var RECORDER_INIT_METRICS_TELEMETRY_NAME = 'Recorder init metrics';
export function startRecorderInitTelemetry(configuration, telemetry, observable) {
  var recorderInitTelemetryEnabled = telemetry.enabled && performDraw(configuration.replayTelemetrySampleRate);
  if (!recorderInitTelemetryEnabled) {
    return {
      stop: noop
    };
  }
  var startContext;
  var documentReadyDuration;
  var recorderSettledDuration;
  var _observable$subscribe = observable.subscribe(function (event) {
      switch (event.type) {
        case 'start':
          startContext = {
            forced: event.forced,
            timestamp: timeStampNow()
          };
          documentReadyDuration = undefined;
          recorderSettledDuration = undefined;
          break;
        case 'document-ready':
          if (startContext) {
            documentReadyDuration = elapsed(startContext.timestamp, timeStampNow());
          }
          break;
        case 'recorder-settled':
          if (startContext) {
            recorderSettledDuration = elapsed(startContext.timestamp, timeStampNow());
          }
          break;
        case 'aborted':
        case 'deflate-encoder-load-failed':
        case 'recorder-load-failed':
        case 'succeeded':
          // Only send metrics for the first attempt at starting the recorder.
          unsubscribe();
          if (startContext) {
            addTelemetryMetrics(RECORDER_INIT_METRICS_TELEMETRY_NAME, {
              metrics: createRecorderInitMetrics(startContext.forced, recorderSettledDuration, elapsed(startContext.timestamp, timeStampNow()), event.type, documentReadyDuration)
            });
          }
          break;
      }
    }),
    unsubscribe = _observable$subscribe.unsubscribe;
  return {
    stop: unsubscribe
  };
}
function createRecorderInitMetrics(forced, loadRecorderModuleDuration, recorderInitDuration, result, waitForDocReadyDuration) {
  return {
    forced: forced,
    loadRecorderModuleDuration: loadRecorderModuleDuration,
    recorderInitDuration: recorderInitDuration,
    result: result,
    waitForDocReadyDuration: waitForDocReadyDuration
  };
}